import React, { useState, useEffect } from "react"
import axios from "axios"
import { useNavigate, useParams, Link } from "react-router-dom"
import { FaAngleLeft, FaAngleRight, FaPlus } from 'react-icons/fa'
import Alert from 'react-bootstrap/Alert'
import { apiURL, filesURL, sitePath } from 'config/globals'
import Topbar from 'components/Topbar'
import CraftRecordNavigation from 'components/CraftRecordNavigation'
import FormRow from 'components/FormRow'
import SaveStepButton from 'components/SaveStepButton'
import { checkAuth } from 'utils/Auth'
import StickyFooter from "components/StickyFooter"
import { Button } from "react-bootstrap"

const craftTypeOptions = [
    { value: 'traditional', label: 'Traditional' },
    { value: 'historical', label: 'Historical' },
    { value: 'experimental', label: 'Experimental' },
]

const CraftRecord2 = () => {
    const [currentUser, setCurrentUser] = useState()
    const [museum, setMuseum] = useState({})
    const [craftRecord, setCraftRecord] = useState({
        type: 'traditional'
    })
    const [form, setForm] = useState()
    const [loadError, setLoadError] = useState('')
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [submitError, setSubmitError] = useState('')

    const navigate = useNavigate()
    const { entityId, craftRecordId } = useParams()
    
    useEffect(() => {
        const start = async () => {
            setCurrentUser(await checkAuth(navigate))
            await getMuseum(entityId)
            if (craftRecordId) {
                await getCraftRecord(craftRecordId)
            }
        }
        start()
    }, [])

    const getMuseum = async (id) => {
        try {
            const response = await axios.get(`${apiURL}/get-museum/${id}`)

            if (!response.data.success) {
                setLoadError("Cannot load museum data: " + (response.data.error || response.data))
                return
            }

            setMuseum(response.data.item)
        } catch (error) {
            setLoadError(JSON.stringify(error))
        }
    }

    const getCraftRecord = async (id) => {
        try {
            const response = await axios.get(`${apiURL}/get-craft-record/${id}`)

            if (!response.data.success) {
                setLoadError("Cannot load record data: " + (response.data.error || response.data))
                return
            }

            setCraftRecord(response.data.item)
        } catch (error) {
            setLoadError(JSON.stringify(error))
        }
    }

    const handleChange = (field, value) => {
        setForm({
            ...form,
            [field]: value
        })
    }

    const handleSubmit = async (event) => {
        event.preventDefault()
        event.stopPropagation()

        setSubmitError('')
        setIsSubmitting(true)

        const submittedForm = {...form}

        try {
            const response = await axios.put(`${apiURL}/update-craft-record/${craftRecord.id}`, submittedForm)
            
            if (!response.data.success) {
                setSubmitError(response.data.error || response.data)
                setIsSubmitting(false)
                return
            }

            setIsSubmitting(false)
            navigate(`/museum/${museum.id}/documentation/craft-records/${craftRecord.id}/edit-context`)
        } catch (error) {
            setSubmitError(JSON.stringify(error))
            setIsSubmitting(false)
        }
    }

    const previousPage = () => {
        navigate(`/museum/${museum.id}/documentation/craft-records/${craftRecord.id}/edit`)
    }

    return (
        <>
            <Topbar currentUser={currentUser} />
            <main className="full-width">
                {museum.id &&
                    <>
                        <div>
                            <Link to={`/museum/${museum.id}/documentation/craft-records`} className="no-decoration"><FaAngleLeft /> Back to Craft Records</Link>
                        </div>
                        <header className="mt-2">
                            <div className="float-start">
                                <h1>Craft Record</h1>
                            </div>
                        </header>
                        <CraftRecordNavigation currentTab="video" museumId={museum.id} craftRecordId={craftRecord.id} />
                        {(!craftRecordId || craftRecord.id) &&
                            <>
                                <FormRow
                                    key="currentVideo"
                                    label="Current video file"
                                    content={
                                        <>
                                            {craftRecord.mainVideo 
                                                ? <div className="mb-4">
                                                    <video width="320" controls>
                                                        <source src={`${filesURL}/${craftRecord.mainVideo}`} type="video/mp4" />
                                                        Your browser does not support the video tag.
                                                    </video>
                                                  </div>
                                                : <>No video uploaded</>
                                            }
                                        </>
                                    }
                                />
                                <FormRow
                                    key="mainVideo"
                                    label="Upload new video file"
                                    content={
                                        <div className="mt-1 mb-3">
                                            <input
                                                type="file"
                                                onChange={(event) => {
                                                    const file = event.target.files[0]
                                                    const reader = new FileReader();
                                                    reader.onloadend = () => {
                                                        handleChange('mainVideo', {
                                                            uri: reader.result,
                                                            name: file.name
                                                        })
                                                    };
                                                    reader.readAsDataURL(file)
                                                }}
                                            />
                                        </div>
                                    }
                                />
                                {submitError && 
                                    <Alert key='submitError' variant='danger'>
                                        {submitError}
                                    </Alert>
                                }
                            </>
                        }
                    </>
                }
                {loadError &&
                    <>
                        <Alert key='loadError' variant='danger'>
                            {loadError}
                        </Alert>
                    </>
                }
                <StickyFooter>
                    <Button size="lg" variant="outline-primary" className="float-start" onClick={previousPage}>
                        <FaAngleLeft /> Previous
                    </Button>
                    <SaveStepButton isSubmitting={isSubmitting} onClick={handleSubmit} />
                </StickyFooter>
            </main>
        </>
    )
}

export default CraftRecord2